import React from 'react'
import { Tooltip } from 'react-tooltip'
import { getTooltipRef } from 'state/imperativeApis/tooltipApi'
import { TREECHAT_TOOLTIP_ID } from 'components/shared/tooltipContract'

const globalCloseEvents = {
    scroll: true,
    resize: true,
    clickOutsideAnchor: true,
}

export default function TreechatTooltip({ className = undefined }) {
    return (
        <Tooltip
            id={TREECHAT_TOOLTIP_ID}
            ref={getTooltipRef()}
            place="bottom"
            delayShow={1000}
            noArrow
            className={className}
            globalCloseEvents={globalCloseEvents}
            portalRoot={typeof document === 'undefined' ? null : document.body}
            positionStrategy="fixed"
            style={{ whiteSpace: 'pre-line' }}
        />
    )
}
